import api from 'services/api';

export async function getTravels(
  filter,
  page = 1,
  { setTravels, setLoading, setPagination, snackbar },
) {
  if (page === 1) setLoading(true);

  try {
    const response = await api.get(`travel-data?${filter}&page=${page}`);
    const { data, ...rest } = response.data;

    setPagination(rest);
    setTravels((oldTravels) => {
      if (page === 1) {
        return data;
      }
      return [...oldTravels, ...data];
    });
  } catch (error) {
    if (error?.response?.status === 400) {
      snackbar.show(error?.response?.data?.message, {
        type: 'error',
      });
    } else {
      snackbar.show('Erro ao buscar viagens', {
        type: 'error',
      });
    }
  } finally {
    setLoading(false);
  }
}
